import type { TowerShipment } from "../../types/controlTower";

// Selección por zona dibujada en el mapa del chofer: qué envíos quedan dentro
// del trazo y el texto que se copia. Puro, sin Leaflet.

export type LatLng = [number, number];

// Ray casting sobre lat/lng: suficiente para zonas de pocos km.
export function pointInPolygon([lat, lng]: LatLng, polygon: LatLng[]): boolean {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [latI, lngI] = polygon[i];
    const [latJ, lngJ] = polygon[j];
    const aboveI = latI > lat;
    const aboveJ = latJ > lat;
    const crosses = aboveI !== aboveJ && lng < ((lngJ - lngI) * (lat - latI)) / (latJ - latI) + lngI;
    if (crosses) inside = !inside;
  }
  return inside;
}

export function shipmentsInside(shipments: TowerShipment[], polygon: LatLng[]): TowerShipment[] {
  if (polygon.length < 3) return [];
  return shipments.filter(
    (s) => s.latitude !== null && s.longitude !== null && pointInPolygon([s.latitude, s.longitude], polygon),
  );
}

// Una dirección por línea, lista para pegar en un mensaje o en un ruteador.
export function addressesText(shipments: TowerShipment[]): string {
  return shipments
    .map((s) => [s.address, s.locality].filter(Boolean).join(", ") || `Sin dirección (${s.tracking})`)
    .join("\n");
}
